// extracted by mini-css-extract-plugin
export default {"errorPageSubText":"membersOnlyTag_errorPageSubText__OjCFy","appNavigationButton":"membersOnlyTag_appNavigationButton__pAWnE","providerTag":"membersOnlyTag_providerTag__Aq+-5"};